/* Experiencia "qué trae" (sets y kits): la foto real del kit y sus piezas, que se tocan una por una para contarlas,
   como al revisar el pedido cuando llega.
   Datos: { "tipo": "que-trae", "foto": 2, "piezas": ["Sartén", "Ollas con tapa de vidrio", { "nombre": "Utensilios", "cantidad": 6, "foto": 5 }] } */
NHX.registrar('que-trae', function (root, d, x) {
  const lista = (Array.isArray(d.piezas) ? d.piezas : (Array.isArray(d.incluye) ? d.incluye : [])).map(p => typeof p === 'string' ? { n: p } : { n: p.nombre || p.titulo || '', c: p.cantidad, f: x.foto(p.foto) }).filter(p => p.n);
  if (lista.length < 2) return false;
  const f = x.foto(d.foto || 1);
  root.innerHTML =
    '<div class="xqt">' +
      '<div class="xqt__stage nhx-stage">' + (f ? x.imgTag(f, 'xqt__img nhx-prod') : '') + '<div class="xqt__det" aria-hidden="true"></div></div>' +
      '<div class="xqt__panel">' +
        '<p class="xqt__k"><span data-c>0</span> de ' + lista.length + ' revisadas</p>' +
        '<div class="xqt__bar" aria-hidden="true"><i></i></div>' +
        '<ol class="xqt__list">' + lista.map((p, i) => '<li><button type="button" aria-pressed="false" data-i="' + i + '"><span class="xqt__n">' + (p.c ? x.esc(p.c) + '×' : String(i + 1).padStart(2, '0')) + '</span><b>' + x.esc(p.n) + '</b><svg class="xqt__ok" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></button></li>').join('') + '</ol>' +
        '<p class="xqt__fin" aria-live="polite"></p>' +
        '<p class="xqt__hint">Toca cada pieza para revisarla, como cuando te llegue.</p>' +
      '</div>' +
    '</div>';
  const bs = Array.from(root.querySelectorAll('[data-i]')), c = root.querySelector('[data-c]'), bar = root.querySelector('.xqt__bar i'), fin = root.querySelector('.xqt__fin');
  const det = root.querySelector('.xqt__det');
  function contar() {
    const n = bs.filter(b => b.getAttribute('aria-pressed') === 'true').length;
    c.textContent = n; bar.style.transform = 'scaleX(' + (n / bs.length) + ')';
    fin.textContent = n === bs.length ? 'Todo esto llega en tu pedido. Lo revisas y pagas al recibir.' : '';
    root.querySelector('.xqt').classList.toggle('is-completo', n === bs.length);
  }
  bs.forEach(b => b.addEventListener('click', () => {
    const on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', on);
    const p = lista[+b.dataset.i];
    if (on && p.f) { det.innerHTML = x.imgTag({ src: p.f.med || p.f.src }, 'nhx-prod', { alt: p.n }); det.classList.add('on'); setTimeout(() => det.classList.remove('on'), 2200); }
    if (on && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
    contar();
  }));
  contar();
  // al verla, la primera pieza se marca sola para mostrar cómo funciona
  x.alVer(root, () => { if (!x.reduce) setTimeout(() => { if (bs[0].getAttribute('aria-pressed') !== 'true') bs[0].click(); }, 900); }, 0.5);
});
